import React from 'react';
import ComboGuestMaterialChooser from 'components/show_drawing/redraw_form/ComboGuestMaterialChooser';
import renderOption from 'components/show_drawing/redraw_form/options/renderOption.jsx';
import styles from 'components/show_drawing/redraw_form/_style.module.scss';

const humanizeGuestName = (guestName) => (
  guestName.split('_').map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')
);

// Guest ask options do not participate in the host's user-changed tracking
// or recommendation engine (no recommendations flow to the guest yet). When
// that changes, wire up a guest-scoped tracker instead of these no-ops.
const NO_OP = () => {};
const EMPTY_LIST = [];

const ComboGuestOptionsSection = ({ combos, activeCombosByGuestName, setRedrawRequested, unit, register, errors }) => {
  const activeSlots = combos.flatMap((group) => {
    const activeRelation = group.relations.find((relation) => activeCombosByGuestName[group.guest_name] === relation.id);
    if (!activeRelation) { return []; }

    const hasAsks = activeRelation.ask_options && activeRelation.ask_options.length > 0;
    const hasMaterials = activeRelation.materials && (
      (activeRelation.materials.groups && activeRelation.materials.groups.length > 0) ||
      activeRelation.materials.ask_custom_material
    );
    if (!hasAsks && !hasMaterials) { return []; }

    return [{ guestName: group.guest_name, relation: activeRelation }];
  });

  if (activeSlots.length === 0) { return null; }

  return (
    <div className={styles.combo_guest_options_section}>
      {activeSlots.map(({ guestName, relation }) => {
        const guestLabel = relation.guest_drawing.catalog_name
          || relation.guest_drawing.friendly_name
          || relation.guest_drawing.name;
        const labelGroup = `combo_guest_${relation.id}`;
        return (
          <div key={relation.id} className={styles.combo_guest_options_group}>
            <strong className={styles.combo_guest_options_title}>
              {humanizeGuestName(guestName)}
            </strong>
            <div className={styles.combo_guest_options_subtitle}>{guestLabel}</div>
            <ComboGuestMaterialChooser
              relation={relation}
              unit={unit}
              register={register}
              errors={errors}
              setRedrawRequested={setRedrawRequested}
            />
            {(relation.ask_options || []).map((option) => renderOption({
              id: relation.guest_drawing.id,
              drawing: relation.guest_drawing,
              option,
              unit,
              optionsUserChanged: EMPTY_LIST,
              addToOptionsUserChanged: NO_OP,
              setRedrawRequested,
              labelGroup,
              inputName: `ask_values[${relation.id}][${option.name}]`
            }))}
          </div>
        );
      })}
    </div>
  );
};

export default ComboGuestOptionsSection;
